<template>
  <div class="Tracking" @click="onClick()">

        <a-scene ref="scene" arjs="sourceType: webcam;" antialias="false">    
    
        <!-- <a-marker preset='hiro' @markerFound="markerFound('hiro')" @markerLost="markerLost" ref="hiro" />  -->
        <!-- <a-marker preset='kanji' @markerFound="markerFound('kanji')" @markerLost="markerLost" ref="kanji" />  -->
          
        <a-marker   type='pattern' 
                    :url="require('./patt/1.patt')"
                    @markerFound="markerFound('marker_1')"
                    @markerLost="markerLost" 
                    ref="marker_1" /> 

        <a-marker   type='pattern' 
                    :url="require('./patt/2.patt')"
                    @markerFound="markerFound('marker_2')"
                    @markerLost="markerLost" 
                    ref="marker_2" /> 

        <a-marker   type='pattern' 
                    :url="require('./patt/3.patt')"
                    @markerFound="markerFound('marker_3')"
                    @markerLost="markerLost" 
                    ref="marker_3" /> 

        <a-marker   type='pattern' 
                    :url="require('./patt/4.patt')"
                    @markerFound="markerFound('marker_4')"
                    @markerLost="markerLost" 
                    ref="marker_4" /> 

        <a-marker   type='pattern' 
                    :url="require('./patt/5.patt')"
                    @markerFound="markerFound('marker_5')"
                    @markerLost="markerLost" 
                    ref="marker_5" /> 

        <a-marker   type='pattern' 
                    :url="require('./patt/6.patt')"
                    @markerFound="markerFound('marker_6')"
                    @markerLost="markerLost" 
                    ref="marker_6" /> 

        <a-marker   type='pattern' 
                    :url="require('./patt/7.patt')"
                    @markerFound="markerFound('marker_7')"
                    @markerLost="markerLost" 
                    ref="marker_7" /> 

        <a-marker   type='pattern' 
                    :url="require('./patt/8.patt')"
                    @markerFound="markerFound('marker_8')"
                    @markerLost="markerLost" 
                    ref="marker_8" /> 

        <a-marker   type='pattern' 
                    :url="require('./patt/9.patt')"
                    @markerFound="markerFound('marker_9')"
                    @markerLost="markerLost" 
                    ref="marker_9" /> 

        <a-marker   type='pattern' 
                    :url="require('./patt/10.patt')"
                    @markerFound="markerFound('marker_10')"
                    @markerLost="markerLost" 
                    ref="marker_10" /> 

        <a-assets>
            <canvas id="asset_canvas" crossOrigin="anonymous" width="1024" height="540"/>
        </a-assets>

        <a-entity ref="box"> 
            <a-entity ref="contenu" rotation="-90 0 0" geometry="primitive: plane; width: 3.76; height: 2.25;" material="src: #asset_canvas;" @loaded="loaded"/>
        </a-entity>

        <a-entity camera />

    </a-scene>

    <div class="Tracking__txt">{{ txt }}</div>
    
    <!-- <canvas id="sprite_canvas" width="256" height="135"/> -->

  </div>
</template>

<script>

import Phaser from 'phaser'

export default {

    name: 'Tracking',
    data: () => ({
        cue: 0,
        img: 0,
        marker: null,
        playing: false,
        initialize: false,
        txt: 'debug',
        rafID: null,
        sequence: 1,
        max: 14,
        canvas: 'asset_canvas',
    }),
    beforeDestroy() {

        if(this.rafID) 
            cancelAnimationFrame(this.rafID)

    },
    created() {

        this.$current = null
        this.$markers = [

            { ref: 'marker_1', patt: '1.patt' },
            { ref: 'marker_2', patt: '2.patt' },
            { ref: 'marker_3', patt: '3.patt' },
            { ref: 'marker_4', patt: '4.patt' },
            { ref: 'marker_5', patt: '5.patt' },
            { ref: 'marker_6', patt: '6.patt' },
            { ref: 'marker_7', patt: '7.patt' },
            { ref: 'marker_8', patt: '8.patt' },
            { ref: 'marker_9', patt: '9.patt' },
            { ref: 'marker_10', patt: '10.patt' },
            { ref: 'marker_11', patt: '11.patt' },
            { ref: 'marker_12', patt: '12.patt' }
        ]

        this.$sequences = [ 'seq1', 'seq2', 'seq3', 'seq4', 'seq5', 'seq6', 'seq7', 'seq13', 'seq14' ]    
        this.$exclude = [ 8, 9, 10, 11, 12, 13 ]
    },

    mounted() {  


        document.addEventListener('keypress', (event) => {
            if(event.keyCode === 32) 
                this.onPress()
        })


        var that = this
        var config = {
            type: Phaser.CANVAS,
            width: 1024,
            height: 540, 
            canvas: document.getElementById(this.canvas),
            // backgroundColor: "#db2000",
            transparent: true,
            scene: {
                preload: function(){ that.preload(this) },
                create: function(){ that.create(this) },
                update: function(){ that.updateCanvas(this) },
            }
        }

        this.$game = new Phaser.Game(config)
    },

    methods: {

        onPress() {
 
            console.log('xxx ' + this.sequence);
            this.stopCurrentSequence()
            // this.sequence = _.random(1,7)
            this.sequence = 1
            this.addMotion()
        },

        preload(scene) {

            _.each(this.$sequences, (seq)=>{
                scene.load.spritesheet(seq, require('@/sequence/'+ seq +'.png'), { frameWidth: 256, frameHeight: 135 })
            })

            scene.load.image('sequence1',require('@/assets/sequence1.png'))
        },

        create(scene) {

            var pos = { x: 1024/2, y: 540/2 }

            _.each(this.$sequences, (seq)=>{

                var last = (seq != 'seq14') ? 119 : 59

                this['$anime_'+ seq] = scene.add.sprite(pos.x, pos.y, seq)
                scene.anims.create({
                    key: 'motion_'+ seq,
                    frames: scene.anims.generateFrameNames(seq, { start: 0, end: last }),
                    frameRate: 24,
                    repeat: 0,
                })

                this['$anime_'+ seq].on('animationcomplete',  (anim, frame)=> { this.sequenceCompleted() }, this['$anime_'+ seq])
                this['$anime_'+ seq].alpha = 0
                this['$anime_'+ seq].setScale(4)

            })

            this['$sequence1'] = scene.add.sprite(pos.x, pos.y, 'sequence1')
            this['$sequence1'].alpha = 0
        },

        sequenceCompleted() {

            console.log('sequenceCompleted');

            if(this.isExclude(this.sequence)) return
            this['$anime_seq'+ this.sequence].alpha = 0
            this.increment()   
        },

        isExclude(ref) {

            const res = (_.indexOf(this.$exclude, ref) === -1) ? false : true
            return res
        },

        increment() {

            this.sequence += 1
            if(this.sequence > this.max) this.sequence = 1
            else this.addMotion()
        },

        addMotion() {

            // console.log(this.sequence);

            if(this['$anime_seq'+ this.sequence]) {

                if(this.sequence === 1) { 
                    this['$sequence1'].alpha = 1 
                    TweenMax.delayedCall(2, ()=>{ this['$sequence1'].alpha = 0 })
                } 
                else { this['$anime_seq'+ this.sequence].alpha = 1 }
                this['$anime_seq'+ this.sequence].anims.play('motion_seq'+ this.sequence)

            } else {

                this.$tween = TweenMax.delayedCall(4, ()=>{ 
                    this.increment()
                })
            }  
        },

        updateCanvas(scene) {
        },

        onClick() {

            this.initialize = true
            this.txt = 'initialize'
        },
        
        loaded() { 

            this.txt = 'loaded'
        },

        update() {

            var marker = this.$refs[this.marker].object3D
            var box = this.$refs.box.object3D
                box.position.copy(marker.position)
                box.rotation.copy(marker.rotation)
                box.scale.copy(marker.scale)
                box.quaternion.copy(marker.quaternion)
                box.position.x += 1.8 
                box.position.y -= 0.84

            this.rafID = requestAnimationFrame(this.update)
        },

        stopCurrentSequence() {

            if(this.$tween) this.$tween.kill()
            if(this['$anime_seq'+ this.sequence]) {
                this['$anime_seq'+ this.sequence].alpha = 0
                this['$anime_seq'+ this.sequence].anims.pause()
            }
        },

        synchronize(time) {

            var seq = (time*30)/120
            this.stopCurrentSequence()

            console.log(seq);

            if(seq >=1) {

                this.sequence = seq
                this.addMotion()
            }
  
        },

        markerFound(marker) {

            console.log('marker ...');

            const time = Number(marker.split('_')[1])

            if((time)*4 === this.cue)
                return

            this.cue = (time)*4
            if( typeof time === 'number') {
                const cc = (marker === 'marker_1') ? 1 : time*4
                this.txt = cc
                this.synchronize(cc)
            } 
            this.marker = marker
            this.update()
        },

        markerLost() {
            if(this.rafID) 
                cancelAnimationFrame(this.rafID)
        },

    }

}
</script>


<style lang="stylus">

.Tracking
    &__txt
        position absolute
        color black
        font-size 40px
        top 10px
        left 40px

#arjsDebugUIContainer
    display none

#sprite_canvas
    border 1px solid yellow
    position absolute
    top 50%
    left 50%
    width 256px
    height 135px
    transform translate(-50%, -50%) scale(4)

</style>










































